type Days = number[];

export const uniqueDays = (days: Days): Days => {
    const unique = [...new Set(days)];

    return unique.sort((a, b) => a - b);
};
